import * as React from "react";
import { useAddressConfiguration } from "../../../../context/AddressConfigurationContext/context/AddressConfigurationContext/AddressConfigurationContext.js";
import Address from "./Address.js";
import { getAddressRows, parseAddress } from "./utils.js";
const AddressContainer = ({ size = "COMPLETE", data = {}, prepend, ...rest }) => {
  const config = useAddressConfiguration();
  const rows = React.useMemo(() => {
    const templateRows = getAddressRows(size, config);
    if (templateRows.length) {
      const addressRows = parseAddress(templateRows, data);
      if (prepend) {
        addressRows[0] = `${prepend}${addressRows[0]}`;
      }
      return addressRows;
    }
    const feedback = `No configuration for address size ${size}`;
    console.error(feedback);
    return [`[${feedback}]`];
  }, [size, config, data, prepend]);
  return /* @__PURE__ */ React.createElement(Address, { ...rest, rows });
};
export {
  AddressContainer as default
};
//# sourceMappingURL=AddressContainer.js.map
